import React from "react";
import { motion } from "framer-motion";

type BrokenLinkProps = {
  message: string;
};

const BrokenLink: React.FC<BrokenLinkProps> = ({ message }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.9, y: 40 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    exit={{ opacity: 0, scale: 0.9, y: 40 }}
    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      color: "#d32f2f",
      background: "#fff0f0",
      borderRadius: "16px",
      boxShadow: "0 2px 24px rgba(0,0,0,0.08)",
      padding: "2rem",
      margin: "2rem",
    }}
  >
    <svg width="72" height="72" fill="none" viewBox="0 0 24 24" style={{ marginBottom: "1rem" }}>
      <circle cx="12" cy="12" r="10" fill="#ffcdd2" />
      <path d="M8 8l8 8M16 8l-8 8" stroke="#d32f2f" strokeWidth="2" strokeLinecap="round" />
    </svg>
    <h1 style={{ fontSize: "1rem", marginBottom: "0.5rem" }}>This link is no longer valid</h1>
    <p className=" text-13">{message}</p>
  </motion.div>
);

export default BrokenLink;
